import React from "react";
import PropTypes from "prop-types";
// Remove unused import
import { useAuth } from "../../contexts/AuthContext";

/**
 * AgentStatusIndicator
 *
 * Displays the current status of an agent with appropriate color coding and text.
 * Can be used for both the current user and other agents.
 */
const AgentStatusIndicator = ({
  status,
  showText = true,
  size = "md",
  className = "",
}) => {
  const { user } = useAuth();

  // Use current user's status if none provided
  const agentStatus = status || user?.status || "offline";

  // Define status colors and text
  const statusConfig = {
    available: {
      color: "bg-green-500",
      text: "Available",
    },
    on_call: {
      color: "bg-red-500",
      text: "On Call",
    },
    break: {
      color: "bg-yellow-500",
      text: "On Break",
    },
    offline: {
      color: "bg-gray-400",
      text: "Offline",
    },
  };

  // Get config for current status (default to offline if unknown status)
  const config = statusConfig[agentStatus] || statusConfig.offline;

  // Size configurations
  const sizeConfig = {
    sm: "w-2 h-2",
    md: "w-3 h-3",
    lg: "w-4 h-4",
  };

  const indicatorSize = sizeConfig[size] || sizeConfig.md;
  const textSize = size === "lg" ? "text-sm" : "text-xs";

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div
        className={`${config.color} rounded-full ${indicatorSize} animate-pulse`}
        title={config.text}
      />
      {showText && (
        <span className={`${textSize} font-medium`}>{config.text}</span>
      )}
    </div>
  );
};

AgentStatusIndicator.propTypes = {
  status: PropTypes.oneOf(["available", "on_call", "break", "offline"]),
  showText: PropTypes.bool,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  className: PropTypes.string,
};

export default AgentStatusIndicator;
